import Controller from "./editableAsyncList.controller";
import template from "./editableAsyncList.html";

const editableAsyncList = {
  template,
  controller: Controller,
  bindings: {
    selected: "<",
    title: "@",
    name: "@",
    eventName: "<",
    permissionName: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    listResource: "@",
    listTransformer: "@",
    listParams: "<",
    emptyMsg: "@",
  },
};

export default editableAsyncList;



// WEBPACK FOOTER //
// ./src/components/editableAsyncList/editableAsyncList.component.js